import { render } from "./App.vue?vue&type=template&id=3b0dfbf4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/scss/app.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script